<template>
  <a-card nopad>
    <div class="booking-title d-flex justify-space-between">
      <span>{{ labelRef }}</span>
      <span>({{ group.pax }} pax)</span>
    </div>
    <div v-if="hasTypePaxMismatch" class="red--text font-weight-bold caption mx-3 px-2 pb-1">
      ** Warning: Room type expects {{ expectedPax }} pax, but these rooms have {{ group.pax }} occupants
    </div>
    <div class="mx-3 px-2">
      <div class="roomfieldlabels subtitle-2">
        <div class="rtitle"></div>
        <div class="namelist">
          <div>
            <span class="namefield">First name</span>
            <span class="namefield">Last name</span>
            <div class="aboutfield"></div>
          </div>
        </div>
        <div class="flex-grow-1">Requests</div>
        <div class="rdelete"></div>
      </div>
    </div>
    <div v-for="(g, index) in group.rooms" :key="index" class="roomrow mx-3 px-2">
      <div class="rtitle">
        <RoomIncludeToggle v-model="g.meta.cancelled" />
        <span class="subtitle-2" :class="{ cancelled: g.meta.cancelled }">{{ "Room " + (index + 1) }}</span>
      </div>
      <div class="namelist" :class="{ cancelled: g.meta.cancelled }">
        <div v-for="(name, j) in g.nameList" :key="j">
          <f-text class="namefield" v-model="name.first" />
          <f-text class="namefield" v-model="name.last" />

          <div class="aboutfield">
            <AboutRoomOccupant v-model="name.about" />
          </div>
        </div>
      </div>
      <div class="flex-grow-1" :class="{ cancelled: g.meta.cancelled }">
        <f-textarea rows="1" v-model="g.meta.request" />
      </div>
      <div class="rdelete">
        <v-btn icon small @click="$emit('popRoom', g.index)">
          <v-icon small>clear</v-icon>
        </v-btn>
      </div>
    </div>
  </a-card>
</template>

<script>
import BOOKING_ROOMS from "@/config/BOOKING_ROOMS";
import AboutRoomOccupant from "./_AboutRoomOccupant";
import RoomIncludeToggle from "./_RoomIncludeToggle";
export default {
  components: {
    AboutRoomOccupant,
    RoomIncludeToggle,
  },
  props: {
    group: Object,
  },
  computed: {
    roomTypeConfig() {
      return BOOKING_ROOMS.find((item) => item.value === this.group.type);
    },
    labelRef() {
      return this.roomTypeConfig ? this.roomTypeConfig.label : this.group.type;
    },
    expectedPax() {
      return this.roomTypeConfig ? this.roomTypeConfig.pax : null;
    },
    hasTypePaxMismatch() {
      if (this.expectedPax == null) return false;
      return Number(this.group.pax) !== Number(this.expectedPax);
    },
  },
  methods: {
    setRequest(group, value) {
      group.meta.request = value;
    },
  },
};
</script>

<style lang="scss">
/* Shared layout parts */
.rtitle {
  width: 120px;
  min-width: 120px;
}
.rdelete {
  width: 30px;
}
.namelist {
  display: flex;
  flex-direction: column;
  max-width: 460px;

  > div {
    display: flex;
    flex-direction: row;
  }
}
.namefield {
  width: 150px;
  display: inline-block;
}
.aboutfield {
  width: 160px;
  display: inline-block;
}

.roomfieldlabels {
  display: flex;
  align-items: flex-end;
  padding-bottom: 4px;

  .namefield {
    padding-left: 12px;
  }

  .flex-grow-1 {
    padding-left: 12px;
  }
}

.roomrow {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border: 1px solid lightgrey;

  .cancelled {
    opacity: 0.5;
    text-decoration: line-through;
  }
}
</style>
